export default __webpack_public_path__ + "static/media/correct4.58178016.mp3";